import React, { useContext } from 'react';
const IntentBehaviorContext = /*#__PURE__*/React.createContext({
  getDisabled: () => false,
  getTooltip: () => null
});
export const useIntentBehavior = () => useContext(IntentBehaviorContext);
export const IntentBehaviorProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement(IntentBehaviorContext.Provider, {
    value: value
  }, children);
};